import { Component, Input, OnInit, OnDestroy } from '@angular/core';

export interface LoaderStep {
    text: string;
    icon: string;
    active?: boolean;
}

@Component({
    selector: 'app-test-generation-loader',
    templateUrl: './test-generation-loader.component.html',
    styleUrls: ['./test-generation-loader.component.scss']
})
export class TestGenerationLoaderComponent implements OnInit, OnDestroy {
    @Input() currentStep = 0;
    @Input() centerIcon = 'auto_awesome';
    @Input() stepIntervalMs = 2500;
    @Input() steps: LoaderStep[] = [
        { text: 'Analyzing your selected topics...', icon: 'psychology', active: true },
        { text: 'Calibrating difficulty curve...', icon: 'gps_fixed', active: false },
        { text: 'Generating tailored questions...', icon: 'auto_awesome', active: false },
        { text: 'Running quality checks...', icon: 'fact_check', active: false },
        { text: 'Your test is almost ready!', icon: 'bolt', active: false },
    ];

    private _interval: any;

    get progress(): number {
        return Math.round((this.currentStep / Math.max(this.steps.length - 1, 1)) * 100);
    }

    ngOnInit(): void {
        this.simulateProgress();
    }

    ngOnDestroy(): void {
        if (this._interval) clearInterval(this._interval);
    }

    simulateProgress(): void {
        let stepIndex = 0;
        this._interval = setInterval(() => {
            if (stepIndex < this.steps.length) {
                this.currentStep = stepIndex;
                this.updateSteps();
                stepIndex++;
            } else {
                clearInterval(this._interval);
            }
        }, this.stepIntervalMs);
    }

    updateSteps(): void {
        this.steps.forEach((step, index) => { step.active = index === this.currentStep; });
    }
}
